import { useState } from 'react';
import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import { Divider } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';


const BarraBotones=(props)=>{
  const [btn, setBtn] = useState(0);

  const presionarBoton =(event, newBtn)=>{
    event.preventDefault()
    setBtn(newBtn)
    props.botones(newBtn)
  }

  return(
    <div className='container'>
      <Divider light />
      <Box component="span" className='mt-3 mb-3'>
        <BottomNavigation
          showLabels
          value={btn}
          onChange={(event, newValue) => {
            presionarBoton(event, newValue);
          }}
        >
          {props.btnActivos[0]===true && <BottomNavigationAction label="Nuevo" icon={<AddCircleIcon />} />}
          {props.btnActivos[1]===true && <BottomNavigationAction label="Grabar" icon={<SaveAsIcon />} />}
          {props.btnActivos[2]===true && <BottomNavigationAction label="Imprimir" icon={<LocalPrintshopIcon />} />}
          {props.btnActivos[3]===true && <BottomNavigationAction label="Exportar" icon={<FilePresentIcon />} />}
          {props.btnActivos[4]===true && <BottomNavigationAction label="Limpiar" icon={<CleaningServicesIcon />} />}
        </BottomNavigation>
      </Box>
      <Divider light />
    </div>
  )
}

export default BarraBotones